<template>
	<div>
		<buyJd :crtNum='2'></buyJd>
		<!-- 中心区域 -->
		<div  class="soConBox">
			<!-- 收货地址模块 -->
			<div class="shAddress">
				<!-- 标题 -->
				<p class="shAddress-titBox ">
					选择收货地址
				</p>
				
				<!-- 地址列表 -->
				<ul class="shAddress-listBox d-rn d-aic d-jcs" v-show="addressList&& addressList.length?true:false">
					<li :class="['shAddress-listBox-itemLiBox','d-cw','d-ais','d-jcs','showHand',
					index==1?'soMarLr':'',selAdsCrt==index?'selAds':'noselAds']" @click="handleSelAddress(index)"
					 v-for="(item,index) in addressList" :key='index'>
						<!-- 省，用户 -->
						<p class="shAddress-listBox-tpNameBox one-txt-cut">
							{{item.addr_province?item.addr_province.slice(0,2):''}}{{item.addr_market}}（{{item.addr_name}}收）
						</p>
						<!-- 详细地址，手机号 -->
						<p class="shAddress-listBox-bmAddressPhone d-cw d-ais d-jcs">
							<span class="one-txt-cut">
								{{item.addr_address}}
							</span>
							<span class="one-txt-cut">
								{{item.addr_phone}}
							</span>
						</p>
						<!-- 修改 -->
						<p class="shAddress-listBox-editBtnBox showHand"
						v-show="selAdsCrt==index?true:false" @click="handleOpenAdsPup(item,index)">
							修改
						</p>
						
						
						<!-- 定位 -->
						<!-- 默认地址 -->
						<p class="shAddress-listBox-adssFixedBox" v-if="2==item.addr_status">
							默认地址
						</p>
						<!-- 默认选中图片==对号 -->
						<img src="../../assets/img/comm/icon_rgtBtmSelAddres.png"
						 class="shAddress-listBox-selDuiBox" v-show="selAdsCrt==index?true:false">
						
					</li>
				</ul>
				<ul class="noAddressBox d-rn d-aic d-jcc" v-show="addressList&& addressList.length?false:true">
					暂无收货地址
				</ul>
				<!-- 菜单按钮 -->
				<ul class="shAddress-menuBox d-rn d-aic d-jcb">
					<li class="showHand" @click="handleOpenAdsPup">使用新地址</li>
					<li class="showHand" @click="handleGoAddress">管理收货地址</li>
				</ul>
			</div>
			
			<!-- 订单信息 -->
			<div class="shOrderInfo">
				<!-- 标题 -->
				<p class="shOrderInfo-titBox">
					确认订单信息
				</p>
				
				<!-- 商品列表 -->
				<div class="shOrderInfo-shopInfo">
					<!-- 标题行 -->
					<ul class="shOrderInfo-shopInfo-titLine d-rn d-aic d-jcs">
						<li>商品信息</li>
						<li>商品属性</li>
						<li>单价</li>
						<li>数量</li>
						<li style="opacity: 0;">优惠券</li>
						<li>小计</li>
					</ul>
					<!-- 商品列表 -->
					<div class="shOrderInfo-shopInfo-shopList d-cw d-ais d-jcs" >
						<!-- 每个商品 -->
						<ul class="shOrderInfo-shopInfo-shopList-itemShopBox d-rn d-ais d-jcs" 
						v-for="(item,index) in orderShopList" :key='index'>
							<!-- 图片 -->
							<img :src="item.goodsImg"
							 class="shOrderInfo-shopInfo-shopList-itemShopImg">
							
							<!-- 商品名称 -->
							<p class="shOrderInfo-shopInfo-shopList-itemShopName txt-cut">
								{{item.goodsTitle}}
							</p>
							
							<!-- 商品属性 -->
							<li class="shOrderInfo-shopInfo-shopList-itemShopGgBox">
								<!-- 一级规格 -->
								<p class="one-txt-cut d-rn">{{item.parentModularName}}：{{item.parentTitle}}</p>
								<!-- 二级规格 -->
								<p class="one-txt-cut soMarTop10 d-rn ">{{item.goodAttrModularName}}：{{item.goodsAttrTitle}}</p>
							</li>
							
							<!-- 单价 -->
							<p class="shOrderInfo-shopInfo-shopList-itemShopMoney one-txt-cut">
								￥{{item.traderGoodsMoney}}
							</p>
							<!-- 数量 -->
							<p class="shOrderInfo-shopInfo-shopList-itemShopNumber one-txt-cut">
								{{item.cartNum}}
							</p>
							<!-- 优惠券 -->
							<p class="shOrderInfo-shopInfo-shopList-itemShopCoupon one-txt-cut" style="opacity: 0;">
								无
							</p>
							<!-- 小计 -->
							<li class="shOrderInfo-shopInfo-shopList-itemShopAddNum one-txt-cut">
								￥{{((item.traderGoodsMoney*100*item.cartNum)/100).toFixed(2)}}
							</li>
						</ul>
					</div>
					
					
					<!-- 优惠券 -->
					<div :class="['carCoupon',couponArr && couponArr.length?'carCouponBor':'']"
					v-show="true">
						<!-- 标题 -->
						<ul class="carCoupon-titBox d-rn d-aic d-jcb">
							<!-- 左=== -->
							<li class="carCoupon-titBox-lftBox d-rn d-aic d-jcs">
								<img src="../../assets/img/comm/icon_couponTit.png" >
								选择优惠券
							</li>
							<!-- 右 -->
							<li class="carCoupon-titBox-rgtBox d-rn d-aic d-jce">
								请选择优惠券
								<img src="../../assets/img/comm/icon_rgtjtGo.png" >
							</li>
						</ul>
						
						<!-- 优惠券列表 -->
						<ul class="carCoupon-listArr d-rw d-aic d-jcs" v-show="couponArr && couponArr.length?true:false">
							<li v-for="(item,index) in couponArr" :key='index'
							:style="{backgroundImage:'url('+item.coupon_settings_back_img+')'}"
							:class="['carCoupon-listArr-itemCou','d-rn','d-aic','d-jcb',(index+1)%3==0?'':'carMr37']">
								<!-- 左=== -->
								<p class="carCoupon-listArr-lftBox d-cw d-ais d-jcb">
									<span class="one-txt-cut">
										{{item.coupon_amount}}元{{item.coupon_request}}优惠券
									</span>
									<span class="one-txt-cut">
										有效期至：{{item.coupon_time}}
									</span>
								</p>
								<p class="carCoupon-listArr-rgtBox d-rn d-aic d-jcc showHand"
								@click="handleSelCoupon(index)">
									{{selCouponCurrent==index?'已选择':'立即使用'}}
								</p>
								<!-- 背景图 -->
								
							</li>
						</ul>
						<!-- 无数据提示 -->
						<ul class="carCoupon-listArr d-rw d-aic d-jcc" v-show="couponArr && couponArr.length?false:true"
						style="padding: 20px 0;font-size: 16px;">
							暂无可使用的优惠券
						</ul>
					</div>
					
					<!-- 运送方式 -->
					<ul class="shOrderInfo-shopInfo-transportType d-rn d-aic d-jcb">
						<!-- 左 -->
						<li class="shOrderInfo-shopInfo-transportType-lftBox d-rn d-aic d-jcs">
							<p>运送方式：</p>
							<p class="one-txt-cut">
								快递   {{shopOrderYfPrice?'':'包邮'}}
							</p>
						</li>
						<!-- 右 -->
						<li class="shOrderInfo-shopInfo-transportType-rgtBox boxNoYs">
							￥{{shopOrderYfPrice && orderShopList && orderShopList.length?
							(((shopOrderYfPrice*100)*orderShopList.length)/100).toFixed(2):'0.00'}}
						</li>
					</ul>
					<!-- 备注信息 -->
					<ul class="shOrderInfo-shopInfo-remarksTxt d-rn d-ais d-jcs">
						<p>备注信息：</p>
						<textarea rows="" v-model="remarksTxt" placeholder="请在此填写备注信息" cols=""></textarea>
					</ul>
					<!-- 合计 -->
					<ul class="shOrderInfo-shopInfo-totalBox d-rn d-aic d-jce">
						<p>合计（含运费）</p>
						<p>￥{{shopJYfAllPrice?shopJYfAllPrice:'0.00'}}</p>
					</ul>
				</div>
			</div>
			
			<!-- 提交订单 -->
			<div class="shOrderBtn d-rn d-aic d-jce">
				<!-- 右侧盒子 -->
				<ul class="shOrderBtn-rgtBox">
					<!-- 上 -->
					<li class="shOrderBtn-topBox d-cw d-aie d-jcs">
						<!-- 一 -->
						<p class="shOrderBtn-topBox-firstBox d-rn d-jce" style="align-items: baseline;">
							<span class="boxNoYs">实付款：</span>
							<!-- <span class="one-txt-cut">￥{{actualPrice?actualPrice.toFixed(2):'0.00'}}</span> -->
							<span class="one-txt-cut">￥{{actualPrice2?actualPrice2.toFixed(2):'0.00'}}</span>
						</p>
						<!-- 二 -->
						<p class="shOrderBtn-topBox-secondBox d-rn d-aic d-jce">
							<span class="boxNoYs">寄送至：</span>
							<!-- 有地址 -->
							<span v-if="addressList && addressList.length" class="one-txt-cut">
								{{addressList[selAdsCrt].addr_province}} {{addressList[selAdsCrt].addr_market}} {{addressList[selAdsCrt].addr_county}} {{addressList[selAdsCrt].addr_address}}
							</span>
							<!-- 没地址 -->
							<span v-else class="one-txt-cut" style="color: #999;">
								请先选择收货地址
							</span>
						</p>
						<!-- 三 -->
						<p class="shOrderBtn-topBox-thirdBox d-rn d-aic d-jce">
							<span class="boxNoYs">收货人：</span>
							<!-- 有地址 -->
							<span v-if="addressList && addressList.length" class="one-txt-cut">
								{{addressList[selAdsCrt].addr_name}} {{addressList[selAdsCrt].addr_phone}}
							</span>
							<!-- 没地址 -->
							<span v-else class="one-txt-cut" style="color: #999;">
								请先选择收货地址
							</span>
						</p>
					</li>
					<!-- 下 -->
					<li class="shOrderBtn-btmBox d-rn d-aic d-jcb">
						<p class="showHand" @click="handleGoShopCar">返回购物车</p>
						<p class="showHand" @click="throttle(handleGoPay,2000)">提交订单</p>
					</li>
				</ul>
			</div>
		</div>
		
		<!-- 地址弹框 -->
		<addressModel v-show="addressBoxState"
		:pageType='adsModelNum'></addressModel>
	</div>
</template>
<script>
	import { 
		selByList,		//地址信息
		getAppCCartByIds,	//id查询商品信息
		yHselByList,	//优惠券
		getFreightByAddress,//运费计算
		appUserPlaceOrder,	//下单接口
	} from '@/api/submitOrder.js'
	import addressModel from '@/components/addressModel'
	import buyJd from '../../components/buyJd'
	let _self;
	export default {
		name:"SubmitOrder",
		data() {
			return {
				// 信息类
				// 用户信息
				userInfo:null,
				// 搜索的ID集合
				seeShopId:null,
				// 商品信息数组
				orderShopList:null,
				// 优惠券列表
				couponArr:[],
				// 地址列表
				addressList:null,
				// 地址盒子的提示信息===1新增2修改
				adsModelNum:1,
				// 运费价格
				shopOrderYfPrice:0,
				// 总价
				shopJYfAllPrice:0,
				// 实付款
				actualPrice:0,
				// 实付款
				actualPrice2:0,
				//备注信息
				remarksTxt:null,
				
				
				// 下标类
				// 当前选中的地址下标
				selAdsCrt:0,
				// 选择使用的优惠券下标
				selCouponCurrent:null,
				// 修改地址的下标
				adsEditIndex:null,
				
				
				
				// 状态类
				// 地址框显示与隐藏
				addressBoxState:false,
				
				
				
				jmsId:this.$store.getters.getJmsId,
				// 点击事件接口请求状态
				isRustState:false,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 显示topbar
			this.$EventBus.$emit('AppCloseNav', true);
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			
			// 判断页面传参信息
			try{
				// 解码获取的路由参数
				let pageVal=decodeURIComponent(_self.$router.history.current.query.id);
				// json化数据
				let jxVal=JSON.parse(pageVal || '{}');
				// 判断页面是否有传值信息
				if(pageVal && jxVal && jxVal.ids){
					// 定义搜索商品的id
					_self.seeShopId=jxVal.ids;
					// console.log('查看ids===',_self.seeShopId);
					// console.log('页面传递参数===',jxVal);
					// 事件监听
					_self.handleAEventsAll();
					
					// 获取商品信息
					_self.handleGetAllShopInfo();
					// 获取优惠券信息
					_self.handleGetAllCoupup();
					// 获取地址信息
					_self.handleGetAddressInfo();
					
				}else{
					// 无页面传值===返回首页
					_self.$router.push('/');
				}
			}catch(err){
				// 出现错误的情况下===》跳转回首页
				_self.$router.push('/');
			}
		},
		// 方法集
		methods: {
			// 事件监听
			handleAEventsAll(){
				// 监听盒子的关闭
				_self.$EventBus.$on('closeAdsPopup',res=>{
					_self.addressBoxState=res;
				})
				// 地址新增/修改===完成后返回信息
				_self.$EventBus.$on('handleAdsInfoReturn',res=>{
					// 查询地址信息接口
					_self.handleGetAddressInfo();
				})
			},
			// 获取所有的商品信息
			handleGetAllShopInfo(){
				// console.log('获取所有的商品信息',_self.seeShopId);
				// 接口请求
				getAppCCartByIds({
					ids:_self.seeShopId
				}).then(res=>{
					// console.log('选择的商品信息===',res);
					if(res.code==200){
						// 定义商品信息
						_self.orderShopList=res.data;
						// 进行价格总金额计算
						// console.log('价格计算11111');
						_self.handleAllShopPriceJs();
					}
				})
			},
			// 获取所有的地址信息
			handleGetAddressInfo(){
				selByList({
					userId:_self.userInfo.userId,
					page:1,
					size:3
				}).then(res=>{
					if(res.code==200 && res.data && res.data.list && res.data.list.length){
						// 有数据===定义收货地址数组
						_self.addressList=res.data.list;
						// 计算运费
						_self.handleJsAddressPrice();
					}
				})
			},
			// 获取所有的优惠券信息
			handleGetAllCoupup(){
				// 优惠券接口
				yHselByList({
					userId:_self.userInfo.userId,
					ucStatus:0,
					// page:1,
					// size:30
				}).then(res=>{
					// 优惠券接口
					// console.log('优惠券接口=====返回值',res);
					if(res.code==200 && res.data && res.data.length){
						// 定义优惠券信息
						_self.couponArr=res.data;
					}
				})
			},
			// 优惠券使用
			handleSelCoupon(val){
				// 定义优惠券选择
				if(_self.selCouponCurrent==val){
					// 定义未选择的优惠券
					_self.selCouponCurrent=null;
					// 进行价格总金额计算
					_self.handleAllShopPriceJs();
					return false;
				}
				// 定义优惠券的使用下标
				_self.selCouponCurrent=val;
				// 进行价格总金额计算
				_self.handleAllShopPriceJs();
			},
			// 选择地址
			handleSelAddress(val){
				// 防止频繁请求
				if(_self.isRustState){
					_self.$jgTips('运费正在请求中，请稍等！');
					return false;
				}
				_self.isRustState=true;
				
				// 定义当前选择的地址
				_self.selAdsCrt=val;
				// 运费计算
				_self.handleJsAddressPrice();
			},
			// 运费计算
			handleJsAddressPrice(){
				console.log('查看地址',_self.selAdsCrt);
				console.log('查看地址',_self.addressList[_self.selAdsCrt]);
				// 运费接口请求
				getFreightByAddress({
					freightProvince:_self.addressList[_self.selAdsCrt].addr_province,
					freightCity:_self.addressList[_self.selAdsCrt].addr_market
				}).then(res=>{
					// console.log('运费价格====',res);
					if(res.code==200){
						
						// console.log('=======',res.data.freightMoney);
						// console.log('=======',_self.orderShopList);
						// 定义运费价格
						_self.shopOrderYfPrice=res.data.freightMoney;
						
						let zhekou = _self.addressList[0].leveldiscount
						
						// 进行价格总金额计算
						// console.log('价格计算33333');
						_self.handleAllShopPriceJs(zhekou);
					}
					// 允许接口请求
					_self.isRustState=false;
				})
			},
			// 商品价格计算
			handleAllShopPriceJs(zhekou){
				// 定义初始价格
				let evePrice=0;
				let evePrice2=0;
				// 循环商品列表
				if(_self.orderShopList && _self.orderShopList.length){
					_self.orderShopList.forEach((it,ix)=>{
						// 合计
						evePrice=evePrice+(it.traderGoodsMoney*100*it.cartNum);
						
						if(zhekou){
							// 实付
							evePrice2=evePrice*Number(zhekou)
						}
					});
				}
				// 是否有邮费
				if(_self.shopOrderYfPrice !=null && _self.shopOrderYfPrice){
					// 有运费
					let newYfPrice=_self.shopOrderYfPrice*100;
					
					// 判断是否有商品
					if(_self.orderShopList && _self.orderShopList.length){
						// console.log('多个商品');
						evePrice=evePrice+newYfPrice * _self.orderShopList.length;
						if(zhekou){
							evePrice2=evePrice2+newYfPrice * _self.orderShopList.length;
						}
					}else{
						// console.log('单个商品');
						evePrice=evePrice+newYfPrice;
						if(zhekou){
							evePrice2=evePrice2+newYfPrice;
						}
						
					}
					// 定义商品+邮费总价格
					_self.shopJYfAllPrice=evePrice/100;
					if(zhekou){
						_self.shopJYfAllPrice2=evePrice2/100;
					}
					
				}
				
				// 判断是否选择了优惠券
				if(_self.selCouponCurrent !=null && _self.selCouponCurrent>=0){
					// 使用了
					// console.log('优惠券吧=====',_self.selCouponCurrent);
					// console.log('优惠券吧=====',_self.couponArr);
					// 计算优惠券的价格
					let copupPrice=_self.couponArr[_self.selCouponCurrent].coupon_amount*100;
					// 重新计算总价格
					evePrice=evePrice-copupPrice;
				}
				
				// 定义实际付款===判断金额是否大于0
				_self.$set(_self,'actualPrice',evePrice>=0?evePrice/100:0);
				if(zhekou){
					_self.$set(_self,'actualPrice2',evePrice2>=0?evePrice2/100:0);
				}else{
					_self.$set(_self,'actualPrice2',evePrice>=0?evePrice/100:0);
				}
				
				
			},
			
			// 支付
			handleGoPay(){
				// 防止频繁请求
				if(_self.isRustState){
					_self.$jgTips('正在请求中，请稍等')
					return false;
				}
				_self.isRustState=true;
				
				
				/* 
					传给下一页面的参数===
					优惠券的使用ID
					商品信息id集合
					总价格==实际付款
				 */
				let requestNeedData={
					// id集合
					pagesId:_self.seeShopId,
					// 优惠券信息
					coupupInfo:_self.selCouponCurrent!=null && _self.selCouponCurrent>=0?_self.couponArr[_self.selCouponCurrent]:null,
					// 备注信息
					bzInfo:_self.remarksTxt,
					// 订单类型===总订单支付
					type:1,
					// 邮费
					freightMoney:_self.shopOrderYfPrice,
					// 折扣价格
					actualPrice2:_self.actualPrice2
					
				}
				// 定义下单接口id集合
				let idsTxt='';
				_self.seeShopId.forEach((itt,ixx)=>{
					if(!ixx){
						idsTxt=itt;
					}else{
						idsTxt=idsTxt+','+itt;
					}
				})
				
				// 下单接口请求
				appUserPlaceOrder({
					// 商品id集合
					cartIds:idsTxt,
					// 商品地址id
					orderAddress:_self.addressList[_self.selAdsCrt].addr_id,
					// 加盟商id
					traderId:_self.jmsId,
					// 用户id
					userId:_self.userInfo.userId,
					// 优惠券id
					couponId:_self.selCouponCurrent!=null && _self.selCouponCurrent>=0?_self.couponArr[_self.selCouponCurrent].uc_id:'',
					// 备注
					orderRemarks:_self.remarksTxt
				}).then(res=>{
					if(res.code==200){
						// 传递订单信息
						requestNeedData.orderInfdo=res.data;
						// console.log('页面传递==信息',requestNeedData);
						// 编码encodeURIComponent() ||  解码decodeURIComponent()
						let pageVal=encodeURIComponent(JSON.stringify(requestNeedData));
						// 不保存当前页面跳转==传递下一页信息
						_self.$router.replace({name:'orderXq',query:{info:pageVal}})
					}
				}).finally(err=>{
					// 允许再次请求
					_self.isRustState=false;
				})
			},
			// 返回购物车
			handleGoShopCar(){
				// 不保存当前页面记录跳转
				_self.$router.replace({name:'ShopCar'})
			},
			// 打开弹窗===修改状态
			handleOpenAdsPup(it,ix){
				// 判断是否为修改
				if(it && ix>=0){
					// 修改状态
					_self.$EventBus.$emit('adsEditInfo',it)
					
					// 定义修改地址的下表
					_self.adsEditIndex=ix;
				}
				// 定义修改弹框===编辑弹窗
				_self.adsModelNum=it && ix>=0?2:1;
				
				
				// 打开弹窗
				_self.addressBoxState=true;
			},
			// 跳转地址管理
			handleGoAddress(){
				// 本地存储下标===地址管理
				localStorage.setItem('menuCurrent', 3);
				// 跳转全部功能页面
				_self.$router.push('/MyInfo')
			}
		},
		// 组件集
		components:{
			buyJd,
			addressModel
		},
		mounted() {
			// 背景色
			document.body.style.background='#FFFFFF';
		},
		watch:{
			// 监听地址盒子打开关闭====禁止页面滑动
			addressBoxState(nval){
				if(nval){
					document.body.style.overflow='hidden'
				}else{
					document.body.style.overflow='auto'
				}
			}
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>
<style lang="scss">
	/* 中心区域 */
	.soConBox{
		width: 1200px;
		min-height: 750px;
		margin: 0 auto;
	}
	/* 地址模块 */
	.shAddress{
		width: 100%;
		box-sizing: border-box;
		/* 标题 */
		&-titBox{
			width: 100%;
			
			font-size: 24px;
			font-weight: 400;
			text-align: left;
			color: #000000;
			letter-spacing: 3px;
		}
		/* 列表 */
		&-listBox{
			width: 100%;
			margin-top: 40px;
			
			/* 每个地址 */
			&-itemLiBox{
				padding: 10px 20px 0;
				box-sizing: border-box;
				width: 386px;
				height: 160px;
				position: relative;
			}
			/* 省，用户 */
			&-tpNameBox{
				width: 100%;
				
				font-size: 24px;
				font-weight: 400;
				text-align: left;
				color: #000000;
				letter-spacing: 3px;
			}
			/* 地址手机号 */
			&-bmAddressPhone{
				width: 100%;
				margin-top: 15px;
				span{
					display: inline-block;
					width: 100%;
					
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 修改按钮 */
			&-editBtnBox{
				margin-top: 15px;
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #e62129;
				letter-spacing: 2px;
			}
			
			/* 定位 */
			/* 默认地址 */
			&-adssFixedBox{
				position: absolute;
				top: 0;
				right: 0;
				width: 70px;
				height: 20px;
				background: rgba(0,0,0,0.3);
				
				text-align: center;
				line-height: 20px;
				font-size: 14px;
				font-weight: 400;
				color: #ffffff;
				letter-spacing: 1px;
			}
			/* 对号 */
			&-selDuiBox{
				width: 40px;
				height: 40px;
				position: absolute;
				bottom: 0;
				right: 0;
			}
		}
		/* 菜单选项 */
		&-menuBox{
			width: 100%;
			margin-top: 40px;
			li:nth-of-type(1){
				width: 172px;
				height: 41px;
				opacity: 1;
				background: #ffffff;
				border: 1px solid #cccccc;
				border-radius: 2px;
				box-sizing: border-box;
				text-align: center;
				line-height: 41px;
				font-size: 24px;
				font-weight: 400;
				color: #666666;
				letter-spacing: 3px;
			}
			li:nth-of-type(2){
				font-size: 24px;
				font-weight: 400;
				color: #ff6e00;
				letter-spacing: 3px;
			}
		}
	}
	/* 地址无数据是 */
	.noAddressBox{
		width: 100%;
		height: 100px;
		text-align: center;
		line-height: 100px;
		font-size: 20px;
		color: #666;
	}
	/* 选中=未选中，地址背景 */
	.selAds{
		background-image: url('../../assets/img/comm/icon_mrAddressImg.png');
		background-size: 100%;
	}
	.noselAds{
		background-image: url('../../assets/img/comm/icon_otherAddressImg.png');
		background-size: 100%;
	}
	
	
	
	/* 优惠券 */
	.carCoupon{
		width: 100%;
		margin-top: 25px;
		/* 标题 */
		&-titBox{
			width: 100%;
			height: 56px;
			background: #ffe7e7;
			border-radius: 4px;
			padding: 0 30px;
			box-sizing: border-box;
			/* 左 */
			&-lftBox{
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #000000;
				letter-spacing: 2px;
				img{
					width: 29px;
					height: 24px;
					margin-right: 10px;
				}
			}
			/* 右 */
			&-rgtBox{
				font-size: 20px;
				font-weight: 400;
				text-align: right;
				color: #666666;
				letter-spacing: 2px;
				img{
					width: 9px;
					height: 18px;
					margin-left: 10px;
				}
			}
		}
		/* 优惠券列表 */
		&-listArr{
			width: 100%;
			padding: 0 30px 35px;
			box-sizing: border-box;
			/* 每个优惠券 */
			&-itemCou{
				width: 355px;
				height: 68px;
				margin-top: 35px;
				background-size: 100%;
				box-sizing: border-box;
			}
			/* 每个优惠券===左侧 */
			&-lftBox{
				width: 245px;
				height: 68px;
				opacity: 1;
				padding: 12px 0 10px 20px;
				box-sizing: border-box;
				overflow: hidden;
				span{
					display: inline-block;
					width: 100%;
				}
				span:nth-of-type(1){
					font-size: 16px;
					font-weight: 700;
					text-align: left;
					color: #ffffff;
				}
				span:nth-of-type(2){
					font-size: 10px;
					font-weight: 400;
					text-align: left;
					color: #ffffff;
				}
			}
			/* 每个优惠券===右侧 */
			&-rgtBox{
				background-size: 100%;
				flex: 1;
				height: 68px;
				
				font-size: 14px;
				font-weight: 700;
				color: #ffffff;
				line-height: 18px;
			}
		}
	}
	/* 右外边距 */
	.carMr37{
		margin-right: 36px;
	}
	/* 边框 */
	.carCouponBor{
		border: 1px solid #cccccc;
		box-sizing: border-box;
	}
	
	
	/* 订单信息模块 */
	.shOrderInfo{
		width: 100%;
		box-sizing: border-box;
		margin-top: 60px;
		/* 标题 */
		&-titBox{
			width: 100%;
			font-size: 24px;
			font-weight: 400;
			text-align: left;
			color: #000000;
			letter-spacing: 3px;
		}
		/* 商品信息 */
		&-shopInfo{
			width: 100%;
			margin-top: 40px;
			box-sizing: border-box;
			/* 首行 */
			&-titLine{
				width: 100%;
				li{
					font-size: 20px;
					font-weight: 400;
					color: #333333;
					letter-spacing: 2px;
				}
				li:nth-of-type(1){
					margin-left: 140px;
				}
				li:nth-of-type(2){
					margin-left: 227px;
				}
				li:nth-of-type(3){
					margin-left: 121px;
				}
				li:nth-of-type(4){
					margin-left: 118px;
				}
				li:nth-of-type(5){
					margin-left: 94px;
				}
				li:nth-of-type(6){
					margin-left: 67px;
				}
			}
			/* 商品列表 */
			&-shopList{
				width: 100%;
				margin-top: 20px;
				border: 1px solid #cccccc;
				padding: 10px 0 20px;
				box-sizing: border-box;
				/* 每个商品 */
				&-itemShopBox{
					width: 100%;
					margin-top: 10px;
					box-sizing: border-box;
				}
				/* 商品图片 */
				&-itemShopImg{
					width: 100px;
					height: 100px;
				}
				/* 商品名称 */
				&-itemShopName{
					margin-left:40px;
					width: 245px;
					font-size: 18px;
					font-weight: 400;
					color: #333333;
					letter-spacing: 2px;
					overflow: hidden;
				}
				/* 商品规格 */
				&-itemShopGgBox{
					margin-left: 39px;
					width: 220px;
					height: 100px;
					overflow-y: scroll;
					overflow-x: hidden;
					padding-left: 30px;
					box-sizing: border-box;
					p{
						flex: 1;
						box-sizing: border-box;
						
						font-size: 18px;
						font-weight: 400;
						text-align: left;
						color: #999999;
						letter-spacing: 2px;
					}
				}
				&-itemShopGgBox::-webkit-scrollbar{
					width: 0px;
					background: none;
				}
				
				/* 单价 */
				&-itemShopMoney{
					margin-left: 18px;
					box-sizing: border-box;
					width: 120px;
					
					font-size: 18px;
					font-weight: 400;
					text-align: left;
					color: #333333;
					letter-spacing: 2px;
				}
				/* 数量 */
				&-itemShopNumber{
					margin-left: 40px;
					width: 43px;
					
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
				/* 无 */
				&-itemShopCoupon {
					margin-left: 100px;
					box-sizing: border-box;
					width: 102px;
					
					
					font-size: 18px;
					font-weight: 400;
					text-align: left;
					color: #818181;
					letter-spacing: 2px;
				}
				/* 小计 */
				&-itemShopAddNum{
					// margin-left: 24px;
					flex: 1;
					box-sizing: border-box;
					
					font-size: 18px;
					font-weight: 700;
					text-align: left;
					color: #e62129;
					letter-spacing: 2px;
				}
				
			}
			/* 运送方式 */
			&-transportType{
				width: 100%;
				height: 74px;
				background: #ebf6ff;
				margin-top: 10px;
				padding: 0 30px;
				box-sizing: border-box;
				&-lftBox{
					flex: 1;
					overflow: hidden;
					p:nth-of-type(1){
						font-size: 18px;
						font-weight: 400;
						text-align: left;
						color: #999999;
						letter-spacing: 2px;
					}
					p:nth-of-type(2){
						flex: 1;
						margin:0 10px;
						
						font-size: 18px;
						font-weight: 400;
						text-align: left;
						color: #000000;
						letter-spacing: 2px;
					}
				}
				&-rgtBox{
					font-size: 18px;
					font-weight: 700;
					text-align: right;
					color: #e62129;
					letter-spacing: 2px;
				}
			}
			/* 备注信息 */
			&-remarksTxt{
				width: 100%;
				height: 160px;
				background: #ebf6ff;
				margin-top: 2px;
				padding: 20px 0 20px 30px;
				box-sizing: border-box;
				p{
					margin-right:10px ;
					font-size: 18px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
				textarea{
					width: 488px;
					height: 120px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #e1e1e1;
					padding: 10px 20px;
					box-sizing: border-box;
					
					font-size: 18px;
					font-weight: 400;
					text-align: left;
					color: #333;
					letter-spacing: 2px;
					overflow-y: hidden;
				}
				textarea::-webkit-input-placeholder{
					font-size: 18px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
				}
			}
			/* 合计 */
			&-totalBox{
				width: 100%;
				height: 74px;
				background: #ebf6ff;
				padding: 0 30px ;
				margin-top: 2px;
				box-sizing: border-box;
				p:nth-of-type(1){
					font-size: 18px;
					font-weight: 400;
					color: #000000;
					letter-spacing: 2px;
				}
				p:nth-of-type(2){
					font-size: 18px;
					font-weight: 700;
					color: #e62129;
					letter-spacing: 2px;
				}
			}
		}
		
	}
	.soMarTop10{
		margin-top: 10px;
	}
	
	/* 提交订单 */
	.shOrderBtn{
		width: 100%;
		margin-top: 10px;
		box-sizing: border-box;
		padding-bottom: 60px;
		/* 右侧盒子 */
		&-rgtBox{
			width: 602px;
			opacity: 1;
			background: #ffffff;
			border: 2px solid #e62129;
			box-sizing: border-box;
			
		}
		/* 上地址信息 */
		&-topBox{
			border-bottom: 2px solid #E62129;
			padding: 30px 20px;
			box-sizing: border-box;
			p{
				overflow: hidden;
			}
			/* 一 */
			&-firstBox{
				width: 100%;
				span:nth-of-type(1){
					font-size: 22px;
					font-weight: 400;
					text-align: right;
					color: #000000;
					letter-spacing: 3px;
				}
				span:nth-of-type(2){
					font-size: 32px;
					font-weight: 700;
					text-align: right;
					color: #e62129;
					letter-spacing: 4px;
				}
			}
			/* 二 */
			&-secondBox{
				margin-top: 30px;
				width: 100%;
				span:nth-of-type(1){
					font-size: 22px;
					font-weight: 400;
					color: #000000;
					letter-spacing: 3px;
				}
				span:nth-of-type(2){
					display: inline-block;
					margin-left: 10px;
					font-size: 22px;
					font-weight: 400;
					color: #666666;
					letter-spacing: 3px;
				}
			}
			/* 三 */
			&-thirdBox{
				width: 100%;
				margin-top: 20px;
				span:nth-of-type(1){
					font-size: 22px;
					font-weight: 400;
					color: #000000;
					letter-spacing: 3px;
				}
				span:nth-of-type(2){
					display: inline-block;
					margin-left: 10px;
					font-size: 22px;
					font-weight: 400;
					color: #666666;
					letter-spacing: 3px;
				}
			}
		}
		/* 下按钮 */
		&-btmBox{
			width: 100%;
			border-top: 2px solid #E62129;
			box-sizing: border-box;
			p{
				width: 50%;
			}
			p:nth-of-type(1){
				height: 72px;
				background: #fff;
				text-align: center;
				line-height: 72px;
				
				font-size: 22px;
				font-weight: 400;
				color: #e62129;
				letter-spacing: 3px;
			}
			p:nth-of-type(2){
				height: 72px;
				background: #e62129;
				text-align: center;
				line-height: 72px;
				
				font-size: 22px;
				font-weight: 700;
				color: #ffffff;
				letter-spacing: 3px;
			}
		}
	}
	/* 天津 */
	.soMarLr{
		margin: 0 21px;
	}
</style>
